import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import { withStyles } from "@material-ui/core/styles";
import { FirebaseContext } from "../../FirebaseInit";
import myStyles from "../Signup/Style";
import AlertHost from "../AlertHost/AlertHost";

const INIT_STATE = {
  email: "",
  error: null,
  open: false,
  loading:false
};

class PwReset extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INIT_STATE };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  toggleAlert() {
    this.setState({ open: !this.state.open });
  }

  handleChange(e) {
    this.setState({ email: e.target.value.trim() });
  }
  handleSubmit(firebase, e) {
    e.preventDefault();
    this.setState({loading:true})
    firebase
      .resetPW(this.state.email)
      .then(() => {
        this.toggleAlert();
        this.setState({ email: "",loading:false,error:null });
      })
      .catch(error => this.setState({ error,loading:false }));
  }
  render() {
    const { classes } = this.props;
    const { email, error, open, loading } = this.state;
    const firebase = this.context;
    return (
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        mx={2}
      >
        <Paper className={classes.paper}>
          <Typography align="center" component="h5" variant="h5">
            Reset Password
          </Typography>
          <form
            onSubmit={this.handleSubmit.bind(this, firebase)}
            className={classes.form}
          >
            <TextField
              name="email"
              label="Enter your email"
              fullWidth
              required
              value={email}
              variant="outlined"
              onChange={this.handleChange}
              margin="normal"
              autoFocus
              disabled={loading}
            />
            <Box my={2}>
              <Button
                type="submit"
                size="large"
                color="primary"
                fullWidth
                variant="contained"
                disabled={loading}

              >
                Send
              </Button>
            </Box>
            {error && <Typography color="error">{error.message}</Typography>}
          </form>
        </Paper>
        <AlertHost
          open={open}
          type="success"
          message="Reset email sent."
          toggleAlert={this.toggleAlert}
        />
      </Box>
    );
  }
}
PwReset.contextType = FirebaseContext;
export default withStyles(myStyles)(PwReset);
